var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / basic / circle-checked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1378 30.9311C7.96782 30.9311 1.34473 24.308 1.34473 16.138C1.34473 7.96795 7.96782 1.34485 16.1378 1.34485C24.3078 1.34485 30.9309 7.96795 30.9309 16.138C30.9309 24.308 24.3078 30.9311 16.1378 30.9311ZM16.1378 28.2414C22.8224 28.2414 28.2413 22.8225 28.2413 16.138C28.2413 9.4534 22.8224 4.0345 16.1378 4.0345C9.45328 4.0345 4.03438 9.4534 4.03438 16.138C4.03438 22.8225 9.45328 28.2414 16.1378 28.2414ZM20.5662 11.1525L13.4482 18.2706L10.3646 15.187L8.46276 17.0889L13.4482 22.0743L22.4681 13.0544L20.5662 11.1525Z",
    fill: "#588930"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.72fd215278282b56344ca709c3d61f7d.svg";
export { ForwardRef as ReactComponent };